import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=d3caf370&scoped=true&"
import script from "./my-account.vue?vue&type=script&lang=js&"
export * from "./my-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3caf370",
  null
  
)

export default component.exports